var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPointCircleGray = function SvgPointCircleGray(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99994 12.0001C2.99994 9.61317 3.94815 7.32399 5.63598 5.63616C7.32381 3.94833 9.61299 3.00012 11.9999 3.00012C14.3869 3.00012 16.6761 3.94833 18.3639 5.63616C20.0517 7.32399 20.9999 9.61317 20.9999 12.0001C20.9999 14.3871 20.0517 16.6763 18.3639 18.3641C16.6761 20.0519 14.3869 21.0001 11.9999 21.0001C9.61299 21.0001 7.32381 20.0519 5.63598 18.3641C3.94815 16.6763 2.99994 14.3871 2.99994 12.0001",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9.31818C9 8.31403 9.7835 7.5 10.75 7.5H12.9375C14.6289 7.5 16 8.92455 16 10.6818C16 12.4391 14.6289 13.8636 12.9375 13.8636H10.75V16.5H9V9.31818ZM10.75 12.0455H12.9375C13.6624 12.0455 14.25 11.4349 14.25 10.6818C14.25 9.9287 13.6624 9.31818 12.9375 9.31818H10.75V12.0455Z",
    fill: "#999999"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPointCircleGray);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "point-circle-gray.0e6a9445dd542b87d4ffe22d7bb59b27.svg";